import styled, { keyframes } from "styled-components";
import LoadingIcon from "../assets/loading-sprite-new.png";

type ScrollContainerStyledProps = {
  filters: boolean;
};

export const ScrollContainer = styled.div<ScrollContainerStyledProps>`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  margin: 0.6rem 0;
  padding-left: ${(filters) => (filters ? 0 : "0.6rem")};
  overflow-y: hidden;

  > img {
    margin: 0.8rem;
  }
`;

const loadingX = keyframes`
0% {
  background-position-x: 0px;
}
100% {
  background-position-x: -1920px;
}`;

const loadingY = keyframes`
0% {
  background-position-y: 0px;
}
100% {
  background-position-y: -800px;
}`;

// TODO: make it sticky in center
// CSS issue: player details chart loading
export const LoadingSpinner = styled.div`
  z-index: 9999;
  color: ${(props) => props.theme.defaultText};
  font-size: 2.4rem;
  border-radius: 50%;
  text-indent: -9999px;
  height: 16rem;
  width: 16rem;
  margin: auto;
  position: fixed;
  top: 40%;
  left: 0;
  right: 0;
  transform: scale(0.5);
  /*  Animation */
  background: ${(props) => props.theme.flashpicksBlue} url(${LoadingIcon})
    no-repeat;
  animation: ${loadingX} 0.2s steps(12) infinite,
    ${loadingY} 1s steps(5) infinite;
`;
